<template>
	<div :class="classNames+ '_dyauth'">
		<div :class="classNames+ '_auth'">
			<ul :class="classNames+ '_authlist'">
				<li :class="classNames+ '_authlist_li'">
					<div :class="classNames+ '_auth_step'">第一步</div>
					<div :class="classNames+ '_auth_content'">
						<h3>抖音开放平台授权（授权后获取并管理你的消息卡片、私信消息）</h3>
						<p v-if="authInfo.step == 1 ">暂无授权账号</p>
						<p v-if="authInfo.step > 1" :class="classNames+ '_auth_avatar'"> 
							<img :src="authInfo.account_info.avatar" :alt="authInfo.account_info.nickname" />
							<span>{{authInfo.account_info.nickname ? authInfo.account_info.nickname : '抖音账号'}}</span>
						</p>
					</div>
					<div :class="classNames+ '_auth_status'">
						<a :class="classNames+ '_auth_succes'" href="javascript:;" v-if="authInfo.step >= 2 && authInfo.surplus_time > 0">已绑定</a>
						<a :class="classNames+ '_auth_succes'" href="javascript:;" v-if="authInfo.step >= 2 && authInfo.surplus_time < 1 ">已过期</a>
						
						<a :class="classNames+ '_auth_link'" href="javascript:;" @click="goDouyinOpenAuth()">{{authInfo.step == 1 ? '去授权' : '重新授权'}}</a>
						
					</div>
				</li>
				<li :class="classNames+ '_authlist_li'" v-if="authInfo.step >= 2">
					<div :class="classNames+ '_auth_step'">第二步</div>
					<div :class="classNames+ '_auth_content'">
						<h3>抖音小程序绑定（绑定后获取你的头像、昵称消息）</h3>
						<p v-if="authInfo.step < 3 ">暂无绑定账号</p>
						<p v-else :class="classNames+ '_auth_avatar'"> 
							<img :src="authInfo.account_info.avatar" :alt="authInfo.account_info.nickname" />
							<span>{{authInfo.account_info.nickname ? authInfo.account_info.nickname : '抖音账号'}}</span>
						</p>
					</div>
					<div :class="classNames+ '_auth_status'">
						<a :class="classNames+ '_auth_succes'" href="javascript:;" v-if="authInfo.step == 3">已绑定</a>
						<a :class="classNames+ '_auth_link'" href="javascript:;" @click="goDouyinBind()" v-if="authInfo.step < 3">去绑定</a>
					</div>
				</li>
			</ul>
		</div>
		<el-dialog :title="titleType + 'APP扫码授权'" :visible.sync="showDouyinDialog" width="664px" height="400px"
			custom-class="dyBind1" @close="handleClosede">
			<div class="qrcode">
				<img :src="deCode" style="height: 200px;" alt="">
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	export default {
		props: {
			authInfo: {
				type: Object,
				default: () => {
					return {
						account_info: {
							avatar: '',
							nickname: ''
						},
						step: 1
					}
				}
			},
			authCode: {
				type: Object,
				default: () => {
					return {
						code: '',
						state: ''
					}
				}
			},
		},
		data() {
			return {
				classNames: 'authList',
				showDouyinDialog: false,
				titleType: '抖音',
				deCode: ''
			}
		},
		watch: {
		    async showDouyinDialog(news) {
		        if (news) {
		            await this.getDeCode()
		            this.checkDyBind()
		        }
		    }
		},
		created(){
			if(this.authCode.code){
				this.douyinOpenBind()
				// code=8a5e48b19a3148dfTiUoh2bRpI8JUL0mCEyt&state=%7B"author_id"%3A"408"%7D
			}
		},
		methods: {
			...mapActions('dymessage', ['dyOpenAuth','dyAuthorBind','dyBindInfo']),
			...mapActions('createDynamic', ['getTacode']),
			async goDouyinOpenAuth(){
				const res = await this.dyOpenAuth()
				if(res){
					window.location.href = res	
				} else {
					this.$message({
						type: 'error',
						duration: 3000,
						message: '授权失败，请重试'
					})
				}
			},
			// 抖音开放平台状态
			async douyinOpenBind(){
				try{
					const author_id = localStorage.getItem('id') || ''
					await this.dyAuthorBind({code: this.authCode.code,author_id: author_id})
					this.$message({
						type: 'success',
						duration: 2000,
						message: '抖音开放平台绑定成功'
					})
					setTimeout(()=> {
						const url = window.location.origin+window.location.pathname
						window.location.replace(url)
					},2000)
				}catch(e){
					console.log('err',e);
				}
			},
			// 绑定抖音号
			goDouyinBind(){
				this.showDouyinDialog = true
			},
			async getDeCode() {
			    let res = await this.getTacode({open_source: 1})
			    this.deCode = res
			},
			handleClosede() {
			    this.showDouyinDialog = false
				if (this.timer) {
				    clearTimeout(this.timer)
				}
			},
			async checkDyBind() {
				const res = await this.dyBindInfo()
				if(res && res.step == 3){
					const url = window.location.origin+window.location.pathname
					window.location.replace(url)
				} else {
					this.timer = setTimeout(() => {
					    this.checkDyBind()
					}, 2000)
				}
			},
			
		}
	}
</script>

<style lang="less" scoped>
	 @classNames: authList;
	 .@{classNames}_auth{
		background-color: #fff;
		position: relative;
		ul,li{
			list-style-type: none;
		}
		.@{classNames}_authlist{

		}
		.@{classNames}_authlist_li{
			padding: 20px;
			border: 1px solid #e7e7e7;
			margin-bottom: 20px;
			display: flex;
			align-items: center;
		}
		
		.@{classNames}_auth_step{
			width: 100px;
			color: #333;
			font-weight: 600;
		}
		.@{classNames}_auth_content{
			flex: 1;
			line-height: 2;
			h3{
				color: #5a5a5a;
				font-size: 14px;
			}
			p{
				color: #a1a1a1;
				font-size: 14px;
			}
			.@{classNames}_auth_avatar{
				display: flex;
				align-items: center;
				img{
					width: 30px;
					height: 30px;
					border-radius: 100%;
					margin-right: 10px;
				}
				span{
					color: #333
				}
			}
		}
		.@{classNames}_auth_status{
			width: 150px;
			font-size: 14px;
			text-align: right;
			
			.@{classNames}_auth_succes{
				color: #fff;
				cursor: pointer;
				text-decoration: none;
				margin-right: 10px;
				display: inline-block;
				padding: 10px 20px;
				background-color: #7f7f7f;
				border-radius: 20px;
			}
			.@{classNames}_auth_link{
				color: #1989FA;
				cursor: pointer;
				text-decoration: none;
			}
		}
		
	 }
</style>